import { FilterOptions } from '@ui/v2/TableFilter/TableFilter'

import { FilterQueryProps } from './FilterFields'

export enum TransactionStatus {
  None = 0,
  AwaitingApproval = 50,
  Pending = 100,
  Completed = 200,
  Cancelled = 300,
  Declined = 400,
  Failed = 500,
  Reversed = 600,
}

export const isTransactionStatusSuccessful = (value: number): boolean => {
  return (
    isTransactionStatusAwaitingApproval(value) ||
    isTransactionStatusPending(value) ||
    isTransactionStatusCompleted(value)
  )
}

export const isTransactionStatusUnSuccessful = (value: number): boolean => {
  return (
    isTransactionStatusCanceled(value) ||
    isTransactionStatusDeclined(value) ||
    isTransactionStatusFailed(value)
  )
}

export const isTransactionStatusAwaitingApproval = (value: number): boolean => {
  return value === TransactionStatus.AwaitingApproval
}

export const isTransactionStatusPending = (value: number): boolean => {
  return value === TransactionStatus.Pending
}

export const isTransactionStatusCompleted = (value: number): boolean => {
  return value === TransactionStatus.Completed
}

export const isTransactionStatusCanceled = (value: number): boolean => {
  return value === TransactionStatus.Cancelled
}

export const isTransactionStatusDeclined = (value: number): boolean => {
  return value === TransactionStatus.Declined
}

export const isTransactionStatusFailed = (value: number): boolean => {
  return value === TransactionStatus.Failed
}

export const expandTransactionStates = (
  search?: FilterQueryProps
): FilterQueryProps | undefined => {
  if (!search) return search

  const searchState = search[FilterOptions.State]
  if (typeof searchState !== 'string' || !searchState) return search

  const expanded = searchState.split(' ').flatMap((state) => {
    const s = Number(state)

    if (s === TransactionStatus.AwaitingApproval) {
      return [TransactionStatus.AwaitingApproval, TransactionStatus.Pending]
    }
    if (s === TransactionStatus.Declined) {
      return [TransactionStatus.Cancelled, TransactionStatus.Declined, TransactionStatus.Failed]
    }
    return [s]
  })

  return {
    ...search,
    [FilterOptions.State]: [...new Set(expanded)].join(' '),
  }
}
